// extracted by mini-css-extract-plugin
export default {"PresentationMode":"Carousel_PresentationMode__YRd5U","Legend":"Carousel_Legend__c9IaS"};